/**
 * Divider HTML Roles
 */
export var DividerRoles;
(function (DividerRoles) {
    DividerRoles["presentation"] = "presentation";
    DividerRoles["separator"] = "separator";
})(DividerRoles || (DividerRoles = {}));
